import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  deleteCategory,
  getCategoryList,
  getProductTypeList,
  updateCategory,
  uploadCategoryImage,
} from "../adminSlice";
import { validateIsFileImageType } from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const EditDeleteCategory = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [order, setOrder] = useState<any>("");
  const [seoName, setSeoName] = useState<any>("");
  const [frontImage, setFrontImage] = useState<any>("");
  const [frontImageUpload, setFrontImageUpload] = useState<any>("");
  const [backImage, setBackImage] = useState<any>("");
  const [backImageUpload, setBackImageUpload] = useState<any>("");
  const [categoryId, setCategoryId] = useState<any>("");
  const [frontImagePreview, setFrontImagePreview] = useState<any>("");
  const [backImagePreview, setBackImagePreview] = useState<any>("");

  useEffect(() => {
    getdata();
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);

        },
      })
    );
  }, []);

  const getdata = () => {
    const postData = {};
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList([...res].sort((a, b) => a?.order - b?.order));
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
  };
  const onchangeOrderNumber = (value: any) => {
    setOrder(value);
  };
  const onchangeSeoName = (value: any) => {
    setSeoName(value);
  };
  const onchangeFrontImage = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setFrontImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadCategoryImage({
          params: file,
          callback: (res: any) => {
            if (res?.data) {
              setFrontImage(res.data?.name);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        })
      );
    }
  };

  const onchangeBackImage = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setBackImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadCategoryImage({
          params: file,
          callback: (res: any) => {
            if (res?.data) {
              setBackImage(res.data?.name);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        })
      );
    }
  };
  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setCategoryId(value?._id);
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
          let tempProductType = res?.data?.filter(
            (item: any) => value?.productTypeId?._id === item?._id
          );
          setProductType(tempProductType[0]);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
    setCategory(value?.name);
    setOrder(value?.order);
    setSeoName(value?.seoName);
    setFrontImage(value?.frontImage);
    setBackImage(value?.backImage);
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteCategory({
        id: value._id,
        callback: (res: any) => {
          getdata();
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    let valid = false;
    if (
      productType === "" ||
      category === "" ||
      order === "" ||
      seoName === "" ||
      frontImage === "" ||
      backImage === ""
    ) {
      valid = true;
    }
    if (productType === "") {
      valid = true;
    }
    return valid;
  };
  const handleUpdate = (e: any) => {
    e.preventDefault();
    let matchFrontImageName = '';
    let matchBackImageName = '';
    if (typeof frontImage === 'string' && frontImage.includes('/')) {
      matchFrontImageName = frontImage.substring(frontImage.lastIndexOf('/') + 1);
    }
    if (typeof backImage === 'string' && backImage.includes('/')) {
      matchBackImageName = backImage.substring(backImage.lastIndexOf('/') + 1);
    }
    const postData: any = {
      name: category,
      seoName: seoName,
      order: order,
      frontImage: matchFrontImageName != "" ? matchFrontImageName : frontImage,
      backImage: matchBackImageName != "" ? matchBackImageName : backImage,
    };
    dispatch(
      updateCategory({
        id: categoryId,
        params: postData,
        callback: (res: any) => {
          if (res?.data?.status === "success") {
            setisEditMode(false);
            getdata();
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const renderTable = () => {
    return (
      <div className="row bxshadow p-2 borderRadius mb-3">
        <div>
          <AdminTable
            tableData={categoryList ? categoryList : []}
            pagename={"category"}
            tableHead={["S.N", "Name", "Order No.", "Seo Name", "Action"]}
            handleEdit={(value: any) => handleEdit(value)}
            handleDelete={(value: any) => handleDelete(value)}
            edit={true}
          />
        </div>
      </div>
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleUpdate}>
        {/* <div className="row bxshadow p-2 borderRadius mb-4 w-75">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Product Type"} />
            <DropdownWithClear
              labelName={"Select Product Type"}
              setInputText={(value: any) => ""}
              options={productTypeList}
              value={productType}
            />
          </div>
        </div> */}
        <div className="row bxshadow p-2 borderRadius mb-4 w-75">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Category"} isRequired />
            <InputField
              // key={"ex2"}
              placeholder={"Enter Category"}
              setInputText={(value: any) => onchangeCategory(value)}
              value={category}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Order number"} isRequired />
            <InputField
              // key={"ex2"}
              placeholder={"Enter Order number"}
              setInputText={(value: any) => onchangeOrderNumber(value)}
              value={order}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"SEO Name"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter SEO Name"}
              setInputText={(value: any) => onchangeSeoName(value)}
              value={seoName}
            />
          </div>
          <div className="col-md-2 mb-3">
            <LabelInput labelName={"Front Image"} isRequired />
            <ImagePickerAndViewer
              value={frontImagePreview ? frontImagePreview : frontImage}
              handleChange={(value: any) => onchangeFrontImage(value)}
              htmlFor={`photo-upload-front`}
              doctype={""} />
          </div>
          <div className="col-md-2 mb-3">
            <LabelInput labelName={"Back Image"} isRequired />
            <ImagePickerAndViewer
              handleChange={(value: any) => onchangeBackImage(value)}
              value={backImagePreview ? backImagePreview : backImage}
              htmlFor={`photo-upload-back`}
              doctype={""} />
          </div>
        </div>

        <div className="col-md-9">
          <div className="col-2 mx-auto">
            <Submitbtn name={"Update"} disabled={validations()} />
          </div>
        </div>
      </form >
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Category"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="">
          {!isEditMode ? (
            <div className="row bxshadow p-2 borderRadius mb-4">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
            </div>
          ) : null}
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteCategory;
